<script>
    import DataTable from "../../components/data-table.svelte";

    let users=[
        {id:1,firstName:"",lastName:"Smith",email:"john.smith@mail.co.uk",dob:"2 May 1995",pupilName:"Jane Smith", pupilUPN: 101454521, Relationship:"Father"},
        {id:1,firstName:"John",lastName:"",email:"john.smith@mail.co.uk",dob:"2 May 1995",pupilName:"Jane Smith", pupilUPN: 101454521, Relationship:"Father"},
        {id:1,firstName:"",lastName:"Schmidt",email:"john.Schmidt@mail.co.uk",dob:"2 May 1995",pupilName:"Mane Schmidt", pupilUPN: 101454521, Relationship:"mother"},
        {id:1,firstName:"",lastName:"Schmidt",email:"john.Schmidt@mail.co.uk",dob:"2 May 1995",pupilName:"Cane Schmidt", pupilUPN: 101454521, Relationship:"gauardian"},
    ];
</script>

<style>
    .card-title{
        background-color: #136f63; 
        color: white;
        padding:0.5rem 0.5rem 0 0.5rem;
    }
    .card-title .material-icons.md1::before { 
        content: "keyboard_arrow_up"; 
    }
    .card-title.collapsed .material-icons.md1::before { 
        content: "keyboard_arrow_down"; 
    }
    .btn{
        color: #2e817d;
        border: 1px solid #2e817d;
    }
</style>

<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#changes">Changes</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#errors">Errors</a>
    </li>
</ul>

<br />

<div class="tab-content">

    <div class="tab-pane active" id="changes">
        <div class="card">

            <div class="card-body with-table">
                <DataTable DataLength={users.length} ResponsiveHeader='0,1'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Last Name</th>                                 
                            <th>Pupil Name</th>
                            <th>Pupil UPN</th>
                            <th>Relationship </th>
                            <th>Updated field</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.pupilName} </td>
                            <td>{user.pupilUPN}</td>
                            <td>{user.Relationship}</td>
                            <td>field name</td>
                        </tr>
                        {/each}
                    </tbody>                    
                </DataTable>
            </div>
        </div>
    </div>

    <div class="tab-pane" id="errors">
        <div class="card">

            <a class="card-title d-block" data-toggle="collapse" href="#names" aria-expanded="true" aria-controls="names">
                <h5 style="float: left;">Invalid Name </h5>
                <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
            </a>

            <div id="names" class="card-body with-table">
                <DataTable DataLength={users.length} ResponsiveHeader='0,1'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Last Name</th>                                 
                            <th>Pupil Name</th>
                            <th>Pupil UPN</th>
                            <th>Relationship </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.pupilName} </td>
                            <td>{user.pupilUPN}</td>
                            <td>{user.Relationship}</td>
                        </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>

        <br />

        <div class="card">

            <a class="card-title d-block" data-toggle="collapse" href="#email" aria-expanded="true" aria-controls="email">
                <h5 style="float: left;">Invalid Email </h5>
                <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
            </a>

            <div id="email" class="card-body with-table">
                
                <DataTable DataLength={users.length} ResponsiveHeader='0,1'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Last Name</th>                                 
                            <th>Pupil Name</th>
                            <th>Pupil UPN</th>
                            <th>Relationship </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.pupilName} </td>
                            <td>{user.pupilUPN}</td>
                            <td>{user.Relationship}</td>
                        </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>

        <br />

        <div class="card">

            <a class="card-title d-block" data-toggle="collapse" href="#mobile" aria-expanded="true" aria-controls="mobile">
                <h5 style="float: left;">Invalid Mobile Number </h5>
                <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
            </a>

            <div id="mobile" class="card-body with-table">
                <DataTable DataLength={users.length} ResponsiveHeader='0,1'>
                    <thead>
                        <tr>
                            <th scope="col" class="sorting_asc" aria-sort="ascending">First Name</th>
                            <th>Last Name</th>                                 
                            <th>Pupil Name</th>
                            <th>Pupil UPN</th>
                            <th>Relationship </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each users as user}
                        <tr>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.pupilName} </td>
                            <td>{user.pupilUPN}</td>
                            <td>{user.Relationship}</td>
                        </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>
    </div>
</div>